import React, { useState } from 'react';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// The browser is sent to the backend /auth/google/start endpoint; Google's redirect URI is configured server-side only.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const GoogleMark = () => (
  <svg className="w-5 h-5" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.5l6.8-6.8C35.8 2.4 30.3 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.9 6.1C12.4 13.4 17.7 9.5 24 9.5z"/>
    <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-2.8-.4-4H24v8.1h12.8c-.3 2.1-1.7 5.3-4.8 7.4l7.4 5.7c4.4-4.1 7.1-10.1 7.1-17.2z"/>
    <path fill="#FBBC05" d="M10.5 28.7A14.6 14.6 0 0 1 9.7 24c0-1.6.3-3.2.8-4.7l-7.9-6.1A24 24 0 0 0 0 24c0 3.9.9 7.5 2.6 10.8l7.9-6.1z"/>
    <path fill="#34A853" d="M24 48c6.5 0 11.9-2.1 15.9-5.8l-7.4-5.7c-2 1.4-4.7 2.4-8.5 2.4-6.3 0-11.6-3.9-13.5-9.7l-7.9 6.1C6.5 42.6 14.6 48 24 48z"/>
  </svg>
);

export const GoogleSignInButton = ({ label = 'Sign in with Google', variant = 'light', testId = 'google-signin-btn' }) => {
  const [busy, setBusy] = useState(false);
  const { toast } = useToast();

  const start = async () => {
    setBusy(true);
    try {
      const r = await axios.get(`${BACKEND_URL}/api/auth/google/config`);
      if (!r.data?.data?.enabled) {
        toast({ title: 'Google sign-in unavailable', description: 'Google sign-in is not configured yet. Please use your email and password.', variant: 'destructive' });
        setBusy(false);
        return;
      }
      window.location.assign(`${BACKEND_URL}/api/auth/google/start`);
    } catch {
      toast({ title: 'Google sign-in unavailable', description: 'Please try again in a moment.', variant: 'destructive' });
      setBusy(false);
    }
  };

  const cls = variant === 'dark'
    ? 'bg-white/10 border-white/20 text-white hover:bg-white/20'
    : 'bg-white border-gray-300 text-gray-800 hover:bg-gray-50';

  return (
    <button type="button" onClick={start} disabled={busy} data-testid={testId}
      className={`w-full flex items-center justify-center gap-3 rounded-md border px-4 py-2.5 text-sm font-medium shadow-sm transition-colors disabled:opacity-60 ${cls}`}>
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <GoogleMark />}
      <span>{label}</span>
    </button>
  );
};

export default GoogleSignInButton;
